import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '$store/rootReducer';
import { ExploreState, SetExploreAction } from '$store/explore/interface';

const initialState: ExploreState = {
  isLoading: true,
  isFailed: false,
  tags: [],
  posts: [],
  nextFrom: 0,
  isLoadingMore: false,
};

export const { actions, reducer } = createSlice({
  name: 'explore',
  initialState,
  reducers: {
    loadExplore(state) {
      state.isLoading = true;
      state.isFailed = false;
    },
    setExplore(state, action: SetExploreAction) {
      const { tags, posts, nextFrom } = action.payload;

      state.tags = tags;
      state.posts = posts;
      state.isLoading = false;
      state.nextFrom = nextFrom;
      state.isLoadingMore = false;
    },
    setFailed(state) {
      state.isLoading = false;
      state.isFailed = true;
    },
    exploreLoadMore(state) {
      state.isLoadingMore = true;
    },
    setExploreMore(state, action: SetExploreAction) {
      const { tags, posts, nextFrom } = action.payload;
      state.isLoadingMore = false;

      const added: { [index: number]: boolean } = {};
      for (let pid of state.posts) {
        added[pid] = true;
      }

      const newPosts = [...state.posts];
      for (let pid of posts) {
        if (!added[pid]) {
          newPosts.push(pid);
        }
      }

      state.posts = newPosts;
      state.tags = tags;
      state.nextFrom = nextFrom;
    },
    setExploreMoreFailed(state) {
      state.isLoadingMore = false;
    },
  }
});

export { reducer as exploreReducer, actions as exploreActions };

export const exploreSelector = (state: RootState) => state.explore;
